import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import { renderCreate, renderEdit, save, remove } from './api';
import Big from 'big.js';

require('plugins/forms');

export default function bind() {
  handleLineEvents();

  $('.button.create').on('click', function(evt) {
    evt.preventDefault();
    displayCreation($(evt.currentTarget).attr('data-invoice_id'));
  });
}

function displayEdition(id) {
  const modal = html => <DetailModal content={html} />;
  return renderEdit(id).then(content => drawModal(modal, content));
}

export function displayCreation(invoiceId) {
  const modal = html => <DetailModal content={html} />;
  return renderCreate(invoiceId).then(content => drawModal(modal, content));
}

function drawModal(renderModal, content) {
  const html = {
    __html: content,
  };

  // Creating modal from server modal
  const modal = ReactDOMServer.renderToStaticMarkup(renderModal(html));

  // Appending content to body
  $(document.body).append(modal);

  // Handling events
  const $modal = $('#line-modal');
  $modal
    .modal({
      onApprove: $element => {
        const $button = $($element);
        $button.addClass('loading');

        // Validate form remotely
        const $form = $modal.find('form');
        const data = new FormData($form[0]);

        const id = $modal.find('#invoiceId').val();

        save(data, id)
          .then(res => res.text())
          .then(
            resp => {
              window.location.reload(true);
            },
            err => {
              $button.removeClass('loading');

              // Display error message
              err.res
                .text()
                .then(content => $modal.find('.content').html(content))
                .then(_ => handleAutocomplete($modal));
            }
          );

        return false;
      },
      onDeny: $element => {
        $modal.modal('hide');
        return true;
      },
      onVisible: () => handleAutocomplete($modal),
      onHidden: () => $modal.remove(),
    })
    .modal('show');
}

function handleAutocomplete($modal) {
  $modal.find('#amount').on('change', function(evt) {
    evt.preventDefault();
    constraintDecimals($(evt.currentTarget), 2);
  });

  // Datepicker
  $modal.find('input.datepicker').datepicker({
    language: 'fr',
    autoclose: true,
    orientation: 'bottom',
  });
}

function constraintDecimals(elt, decimals) {
  if (elt && $(elt).val()) {
    const value = $(elt).val();
    $(elt).val(Big(value).toFixed(decimals));
  }
}

function handleLineEvents() {
  $('.line').on('click', 'td:not(:first)', function(evt) {
    evt.preventDefault();
    const elt = $(evt.currentTarget).parents('tr');
    const id = elt.attr('data-id');

    displayEdition(id);
  });

  $('.button.delete').on('click', function(evt) {
    evt.preventDefault();
    const elt = $(evt.currentTarget).parents('tr');
    const id = elt.attr('data-id');

    remove(id)
      .then(res => res.text())
      .then(resp => {
        window.location.reload(true);
      });
  });
}

const DetailModal = ({ content }) => (
  <div id="line-modal" className="ui small modal billLine">
    <i className="close icon" />
    <div className="header">Edition de la ligne</div>
    <div className="content">
      <div dangerouslySetInnerHTML={content} />
    </div>
    <div className="actions">
      <button className="ui approve primary button icon labeled">
        <i className="icon add" />Editer
      </button>
    </div>
  </div>
);

DetailModal.propTypes = {
  content: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/payments/index.js